import { useCustomGetJobDepositStatusQuery } from "generated/graphql";

export default function useJobDepositStatus(id: string) {
  return useCustomGetJobDepositStatusQuery({
    variables: { id },
    fetchPolicy: "cache-and-network",
  });
}
